import { getGlobalClassNames, getInputFocusStyle } from '../../Styling';
import { IsFocusVisibleClassName } from '../../Utilities';
export var DocumentCardTitleGlobalClassNames = {
    root: 'ms-DocumentCardTitle',
};
export var getStyles = function (props) {
    var _a;
    var theme = props.theme, className = props.className, showAsSecondaryTitle = props.showAsSecondaryTitle;
    var palette = theme.palette, fonts = theme.fonts, effects = theme.effects;
    var classNames = getGlobalClassNames(DocumentCardTitleGlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            showAsSecondaryTitle ? fonts.medium : fonts.large,
            {
                padding: '8px 16px',
                display: 'block',
                overflow: 'hidden',
                position: 'relative',
                wordWrap: 'break-word',
                height: showAsSecondaryTitle ? '45px' : '38px',
                lineHeight: showAsSecondaryTitle ? '18px' : '21px',
                color: showAsSecondaryTitle ? palette.neutralSecondary : palette.neutralPrimary,
                selectors: (_a = {
                        ':focus': {
                            outline: '0px solid',
                        }
                    },
                    _a["." + IsFocusVisibleClassName + " &:focus"] = getInputFocusStyle(palette.neutralSecondary, effects.roundedCorner2),
                    _a),
            },
            className,
        ],
    };
};
//# sourceMappingURL=DocumentCardTitle.styles.js.map